export const ACTIONS_UPDATE_REDUCER = {
  CALL_UPDATE_API: "call-update-api",
  CALL_UPDATE_API_SUCCESS: "call-update-api-success",
  CALL_UPDATE_API_ERROR: "call-update-api-error",
  INITIAL_DATA: "initial-data", // update by initial all form data
  UPDATE_DATA: 'update-data' // update field by field when onchange
}

export const formSettingReducer = (formValues, action) => {
  switch (action.type){
    case ACTIONS_UPDATE_REDUCER.CALL_UPDATE_API: {
      return {...formValues, isSubmitting: true};
    }
    case ACTIONS_UPDATE_REDUCER.CALL_UPDATE_API_SUCCESS: {
      return { isSubmitting: false, formValues: action.data}
    }
    case ACTIONS_UPDATE_REDUCER.CALL_UPDATE_API_ERROR: {
      return {...formValues, isSubmitting: false, error: action.error }
    }
    case ACTIONS_UPDATE_REDUCER.INITIAL_DATA: {
      console.log("data", action.data);
      return {isSubmitting: false, formValues: action.data}
    }
    case ACTIONS_UPDATE_REDUCER.UPDATE_DATA: {
      const {name, value} = action.data;
      return {submitError: null, isSubmitting:false, ...formValues,[name]: value}
    }
    default:
      return formValues;
  }
}